<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs4>
                <v-autocomplete
                  label="流程状态"
                  clearable
                  :rules="rules.required"
                  v-model="item.processStateId"
                  item-text="name"
                  item-value="dbid"
                  :items="processStateItems"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'
  import XUserSelectForm from '@/components/global/UserSelectForm'
  const  baseUri= '/api/inte/intellectualRegist/manage'
  const processStateUri= '/api/inte/processState'
  export default {
    mixins: [mixin.edit(baseUri)],

    components: {XUserSelectForm},
    data() {
      return {
        formValid: false,
        item: {},
        freshItem: {
          "name": "",
          "typeId":"",
          "type": "",
          "affiliation": "",
          "departmentId": "",
          "department": "",
          "agencyId": "",
          "agency": "",
          "source": "",
          "contractId":"",
          "submitDate": "",
          "status": "",
          "outcomeState": "",
          "apps": [],
          "orgs": [],
          "agentId": "",
          "agent": "",
          "managerId": "",
          "manager": "",
          "processStateId": "",
          "processState": "",
          "outcomeStateId": "",
          "processStateDate": "",
          "number": "",
          "notes":"",
          "attachments": []
        },
        appDateMenu: false,
        processStateItems: [],

        /**
         * 验证规则
         */
        rules: {
          processStateId: [v => !!v || '必填项。']
        }
      }
    },

    created() {
      // 加载审核状态
      this.axios.all([
        this.axios.get(processStateUri, {params: {sort: 'order.asc'}})
      ]).then(
        this.axios.spread(
          (rspPState) => {
            this.processStateItems = rspPState.data.items;
          }
        )
      )
    },

    watch: {

    },

    computed: {

    },

    methods: {
      // mixin 加载数据后调用
      // afterGetData(data) {
      // },
    }
  }
</script>
